// 内置常用 emoji 集，按类分组。覆盖访客最常用场景；不引入字体或外部包。
// 客户端只渲染纯 unicode 字符；绝大多数现代浏览器原生即可显示。
export const EMOJI_GROUPS: { name: string; chars: string[] }[] = [
  {
    name: 'Frequently Used',
    chars: ['😀', '😂', '😅', '🙂', '😉', '😍', '😘', '🤔', '😎', '😭', '😡', '🥰', '🤗', '🙏', '👍', '👌', '👏', '🎉'],
  },
  {
    name: 'Smileys',
    chars: ['😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '🥰', '😗', '😙', '😚', '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '🥱', '😴', '😌', '😛', '😜', '🤪', '😝', '🤤'],
  },
  {
    name: 'Gestures',
    chars: ['👍', '👎', '👌', '🤝', '👏', '🙏', '✋', '🤚', '🖐️', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✊', '👊', '🫶', '💪'],
  },
  {
    name: 'Mood',
    chars: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟'],
  },
  {
    name: 'Other',
    chars: ['🎉', '🎊', '✨', '🔥', '💯', '⭐', '🌟', '⚡', '☀️', '🌈', '🌹', '🌸', '🍀', '🎁', '🎂', '🍰', '🍻', '☕', '🍵', '🍔', '🍕'],
  },
];
